import { useState } from 'react';
import classNames from 'classnames';

import style from './Input.module.scss';

const {
  formItem,
  formItemLabel,
  formItemElement,
  active,
  error,
  formItemInput,
  formItemError,
  password,
  formItemDs20,
} = style;

const Input = ({
  type = 'text',
  id,
  containerClassName,
  className,
  elementClassName,
  label,
  placeholder,
  value,
  errorMessage,
  onFocus,
  onBlur,
  onChange,
  disabled = false,
  variant = 'default',
}) => {
  const [focused, setFocused] = useState(false);

  const handleOnChange = (event) => {
    const {
      target: {
        value: newValue,
      },
    } = event;

    if (typeof onChange === 'function') {
      onChange(newValue);
    }
  };

  const handleOnFocus = () => {
    setFocused(true);

    if (typeof onFocus === 'function') {
      onFocus();
    }
  };

  const handleOnBlur = () => {
    setFocused(false);

    if (typeof onBlur === 'function') {
      onBlur();
    }
  };

  return (
    <div className={classNames(formItem, containerClassName, { [formItemDs20]: variant === 'ds20' })}>
      {label && (
        <p className={formItemLabel}>
          {label}
        </p>
      )}
      <div className={classNames(formItemElement, className, {
        [active]: focused, [error]: errorMessage,
      })}
      >
        <input
          type={type}
          id={id}
          className={classNames(formItemInput, elementClassName, { [password]: type === 'password', 'ph-no-capture': ['password', 'tel'].includes(type) })}
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          onFocus={handleOnFocus}
          onBlur={handleOnBlur}
          onChange={handleOnChange}
          {...(['password', 'tel'].includes(type) && { 'data-private': 'redact' })}
        />
      </div>
      {errorMessage && typeof errorMessage === 'string' && (
        <p className={formItemError}>
          {errorMessage}
        </p>
      )}
    </div>
  );
};

export default Input;
